import { LoginManagementState } from '../initial.state';
import { LoginManagementActionTypes } from '../actions/loginManagement.actions';

function loginReducer(state = new LoginManagementState(), action) {
  switch (action.type) {
    case LoginManagementActionTypes.OTP_CREATED_SUCCESS:
      return {
        ...state,
        isOTPcreated: true,
      };
    case LoginManagementActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isOTPcreated: false,
        loginSuccess: true,
      };
    case LoginManagementActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isOTPcreated: false,
        loginSuccess: false,
      };
    default:
      return state;
  }
}

export { loginReducer };
